module.exports = "https://static.wmbcdn.com/uniweb/images/ac74483a326eb8828fe677d3d88b9682.svg";